/**
 * 中移香港（MyLink）场景下，多语言 key 与接口 X-lang 取值的映射
 */
export const CMHKLangMap = {
  sc: 'zhCn',
  tc: 'zhTc',
  en: 'zhTc',
}
